<template>
    <div>
        <v-btn
            icon
            dark
            small
            color="white"
            class="close-btn close-btn-left d-none d-md-block"
            elevation="1"
            @click="closeNotes">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <UtilsContent @close-action="closeNotes">
            <template v-slot:header>
                <div class="d-flex flex-row justify-start align-center mx-3">
                    <img :src="indexImg" class="img-index mr-2" alt="" />
                    <div class="align-middle text-left line-height-100">
                        <p class="font-size-16 font-weight-bolder ma-0 text--primary">
                            {{ $t('bookReading.notes') }}
                        </p>
                        <small class="font-size-12">My notes</small>
                    </div>
                </div>
            </template>
            <template v-slot:content>
                <div class="mx-3">
                    <div class="d-flex flex-column">
                        <v-checkbox
                            data-cy="stickyNotes-show-all-notes-button"
                            v-model="bookReadConf.showNotes"
                            :label="$t('bookReading.showAllNotes')"
                        />
                    </div>
                    <div
                        class="d-flex flex-column chapters-container"
                        id="chapter-container"
                        v-if="bookUserNotes.length"
                    >
                        <NoteItem
                            data-cy="stickyNotes-note-item"
                            v-for="(note, index) of bookUserNotes"
                            :key="index"
                            :note_data="note"
                        />
                    </div>
                    <div class=" d-flex flex-column chapters-container" v-else>
                        <span class="text-h6 text-center">
                            {{ $t('bookReading.without_notes') }}
                        </span>
                    </div>
                </div>
            </template>
            <template v-slot:actions>
                <!-- <v-btn
                    color="#95afad"
                    fab
                    small
                    dark
                    class="mt-5 text--white"
                    @click="downScroll"
                    v-if="bookUserNotes.length"
                >
                    <v-icon dark class="text--white">mdi-arrow-down</v-icon>
                </v-btn> -->
            </template>
        </UtilsContent>
    </div>
</template>
<script>
/* eslint-disable global-require */
import { mapState } from 'vuex'

import UtilsContent from '@/components/core/utils/UtilsContent.vue'
import NoteItem from './items/NoteItem.vue'

export default {
    components: {
        UtilsContent,
        NoteItem,
    },
    computed: {
        ...mapState({
            bookUserNotes: (state) => state.bookReading.bookUserNotes,
            currentChapter: (state) => state.bookReading.currentChapter,
            bookReadConf: (state) => state.bookReading.bookReadConf,
        }),
        texts() {
            return {
                notesTxt: {
                    text: this.$t('bookReading.notes'),
                    trl: this.$i18n.locale === 'es' ? 'Mis notas' : 'My notes',
                },
            }
        }
    },
    data() {
        return {
            indexImg: require('@/assets/img/icons/new-reading/notes-purple.svg'),
        }
    },
    methods: {
        downScroll() {
            const el = document.getElementById('chapter-container')
            el.scrollTop += 10
        },
        closeNotes() {
            this.$emit('close-note')
        },
    },
}
</script>
<style>
.chapters-container {
    height: 35vh;
    max-height: 35vh;
    overflow: auto;
}
</style>
